export enum BatchMarkingElement {
  Factory = 1,
  Dispenser = 2,
  Tank = 4
}

(BatchMarkingElement as any).__typeName = 'BatchMarkingElement';
(BatchMarkingElement as any).__isFlags = true;
